import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { getToken } from "../../utils/getToken";

export const useApplicationActionMutation = () => {
  const token = getToken();

  return useMutation({
    mutationFn: ({ applicationId, type }: any) =>
      axiosInstance
        .patch(`/credits/${applicationId}/${type}`, null, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => res.data),
    onSuccess: async () => {
      // message.success(data?.message || `Application  successfully.`);
    },
    onError: (error: any) => {
      message.error(
        error?.response?.data?.message || `Failed. Please try again.`
      );
    },
  });
};
